import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import SectionHeading from '../../components/ui/SectionHeading';
import AnimatedSection from '../../components/ui/AnimatedSection';

const AiCitationArticle = () => {
  useSEO({
    title: 'AI Search & Citation SEO NYC | ChatGPT & Gemini Optimization',
    description: 'Optimize your NYC brand for AI search engines. We build the citations and entity authority required to rank in ChatGPT, Gemini, and Claude.',
  });

  return (
    <div className="pt-20 pb-24 bg-slate-950">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <SectionHeading 
            subtitle="The AI Revolution" 
            title="AI Citations & Entity Optimization" 
          />
        </AnimatedSection>
        
        <div className="prose prose-invert prose-lg max-w-none text-slate-300 space-y-8">
          <p className="text-xl text-white font-medium leading-relaxed">
            The era of the "10 blue links" is fading. Today, users ask ChatGPT for recommendations. If your brand isn't in its training data or citation network, you don't exist.
          </p>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Building Entity Authority</h3>
            <p>
              AI models don't just look at keywords; they look at "entities"—concepts that are distinct and well-defined. We use high-level schema and structured data to define your business as a trusted entity in the NYC ecosystem.
            </p>
          </section>

          <div className="bg-gradient-to-br from-blue-900/20 to-purple-900/20 p-8 rounded-2xl border border-white/10 my-10">
            <h4 className="text-white font-bold mb-4">How We Optimize for AI:</h4>
            <ul className="space-y-3">
              <li className="flex items-start"><span className="text-purple-400 font-bold mr-3">01.</span> <span><strong>Knowledge Graph Integration:</strong> Syncing your data with major knowledge bases.</span></li>
              <li className="flex items-start"><span className="text-purple-400 font-bold mr-3">02.</span> <span><strong>Citation Consistency:</strong> Ensuring every mention of your brand across the web is identical.</span></li>
              <li className="flex items-start"><span className="text-purple-400 font-bold mr-3">03.</span> <span><strong>LLM Data Sourcing:</strong> Identifying the datasets AI models use to make local NYC recommendations.</span></li>
            </ul>
          </div>

          <section>
            <h3 className="text-2xl font-bold text-white mb-4">Future-Proofing Your Visibility</h3>
            <p>
              By establishing your brand as a "source of truth," we ensure that when an AI agent is asked to find the best service in Manhattan, your name is the one it synthesizes into its answer.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AiCitationArticle;